module.exports = __webpack_public_path__ + "static/media/logo_small.e57d8847.svg";